// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_KC3","cls2":"CiterightLanding-cls2_axo CiterightLanding-cls1_KC3"};